import { __assign, __rest } from "tslib";
import React from 'react';
import TextButton from '../../../../../Buttons/TextButton';
import s from './CancelButton.scss';
var CancelButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(TextButton, __assign({ size: "large", variant: "main", className: s['root'] }, rest), children));
};
CancelButton.displayName = 'CancelButton';
export default CancelButton;
//# sourceMappingURL=CancelButton.js.map